import { useQuery } from '@tanstack/react-query';
import { Navigate, useLocation } from 'react-router-dom';
import api from './axiosInstance';
import { useAuth } from './AuthContext';
export default function RequireAuth({ children }) {
  const { token } = useAuth();
  const location = useLocation();
  const { isPending, error } = useQuery({ queryKey: ['session', token], queryFn: () => api.get('/auth/check-session'), enabled: !!token, retry: false, staleTime: 60000 });
  if (!token || error?.response?.status === 401) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (isPending) return <div className="empty-state" role="status">Checking your session…</div>;
  if (error) return <div className="alert error" role="alert">The server is unavailable. Please try again when the backend is running.</div>;
  return children;
}
